import React from "react";
import Navbutton from "../navbutton/Navbutton";
import fundofolha from "../image/fundofolha.jpg";
import './Blog.css';
import SiYourtraveldottv from "../image/SiYourtraveldottv.png";
import Header from "../components/Header";

const ArticlePage = () => {
  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <div className="article-container">
      <Header />

      <header className="article-header">
        <h1 className="article-title">Due Diligence <span>Ambiental</span>: Entenda Sua Importância e Benefícios</h1>
        <p className="article-date">Publicado em: 16 de Janeiro, 2025</p>
      </header>

      <section className="article-main-content">
        <img
          src={SiYourtraveldottv} // Substitua pelo caminho da imagem
          alt="Due Diligence Ambiental"
          className="article-image"
        />
        <p className="article-paragraph">
          Neste blog, exploraremos detalhadamente o que é a Due Diligence Ambiental, como funciona e, mais importante, qual é sua finalidade. Esse processo vai além de uma simples análise ambiental, sendo uma investigação abrangente que identifica riscos, passivos e oportunidades relacionados ao impacto ambiental de uma propriedade ou projeto.
        </p>

        <h2 className="article-subtitle">O que é Due Diligence Ambiental?</h2>
        <p className="article-paragraph">
          A Due Diligence Ambiental consiste em uma avaliação detalhada de diversos fatores ambientais, garantindo que o imóvel ou empreendimento esteja em conformidade com as legislações vigentes e com práticas de sustentabilidade. Entre os principais aspectos analisados, estão:
        </p>
        <ul className="article-list">
          <li><strong>Histórico de Uso do Solo:</strong> Identificação de atividades anteriores que possam ter causado contaminação;</li>
          <li><strong>Conformidade Legal:</strong> Verificação de licenças e autorizações ambientais;</li>
          <li><strong>Avaliação de Impacto Ambiental:</strong> Identificação de possíveis impactos e medidas para mitigá-los;</li>
          <li><strong>Passivos Ambientais:</strong> Análise de responsabilidades ambientais que possam gerar custos futuros.</li>
        </ul>
        <p className="article-paragraph">
          A Due Diligence Ambiental desempenha um papel fundamental para empresas que buscam operar de forma sustentável e responsável. Esse processo permite identificar e prevenir problemas futuros, como multas, sanções ou altos custos com remediação ambiental, garantindo assim a mitigação de riscos. Além disso, assegura o cumprimento das leis ambientais, promovendo segurança jurídica e reduzindo o risco de litígios.
        </p>
        <p className="article-paragraph">
          Com informações detalhadas e confiáveis, a Due Diligence Ambiental orienta decisões estratégicas, como fusões, aquisições e expansões, permitindo que essas ações sejam realizadas com maior assertividade. Assim, investir nesse processo não é apenas uma medida preventiva, mas também uma estratégia para consolidar a imagem corporativa e promover um crescimento responsável e sustentável.
        </p>

        <h2 className="article-subtitle">Como a Due Diligence Ambiental beneficia sua empresa?</h2>
        <p className="article-paragraph">
          Empresas que realizam a Due Diligence Ambiental de forma eficaz podem alcançar resultados significativos em diversas áreas. A identificação antecipada de passivos ambientais permite a redução de custos, evitando despesas inesperadas com remediações ou penalidades. Além disso, ao demonstrar compromisso com a sustentabilidade, essas empresas fortalecem sua reputação, conquistando maior confiança de clientes, parceiros e comunidades. Essa postura também atrai investidores que priorizam projetos responsáveis e alinhados com critérios ambientais, sociais e de governança. Por fim, ao adotar práticas conformes e sustentáveis, as empresas se tornam mais competitivas no mercado, destacando-se em relação aos concorrentes e conquistando novos espaços.
        </p>

        <h2 className="article-subtitle">Como uma consultoria pode ajudar?</h2>
        <p className="article-paragraph">
          O sucesso da Due Diligence Ambiental está diretamente ligado à expertise de uma equipe qualificada, composta por profissionais multidisciplinares das áreas técnica e jurídica. Essa abordagem garante uma análise abrangente, capaz de minimizar riscos e maximizar oportunidades.
        </p>
        <p className="article-paragraph">
          Se você está planejando expandir suas operações ou iniciar um projeto, contar com uma Due Diligence Ambiental bem estruturada é essencial para evitar contratempos e assegurar a sustentabilidade do negócio.
        </p>
        <p className="article-paragraph">
          <strong>A Biolink faz parte da solução!</strong> Nossa equipe especializada está pronta para oferecer todo o suporte necessário, desde a identificação de passivos até a garantia de conformidade legal. Entre em contato conosco para falar com um de nossos especialistas ambientais e descubra como podemos ajudar a proteger seu empreendimento e o meio ambiente.
        </p>
        <p className="article-paragraph">
          #Biolink #BlogBiolink #Sustentabilidade #ConsultoriaAmbiental #MeioAmbiente #DueDiligence
        </p>
      </section>

      <div className="back-button-container">
        <button onClick={handleGoBack} className="back-button">
          <i className="fas fa-arrow-left"></i>
          Outros artigos
        </button>
      </div>

      <section
        className="footer"
        style={{
          background: `linear-gradient(rgba(255, 255, 255, 0.5), rgba(138, 138, 138, 0.5)), url(${fundofolha})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          color: "#fff",
        }}
      >
        <div className="box-container">
          <div className="box">
            <h3>Navegue</h3>
            <a href="#home"><i className="fas fa-chevron-right"></i> Início</a>
            <a href="#about"><i className="fas fa-chevron-right"></i> Sobre</a>
            <a href="#services"><i className="fas fa-chevron-right"></i> Serviços</a>
            <a href="#doctors"><i className="fas fa-chevron-right"></i> Equipe</a>
            <a href="#book"><i className="fas fa-chevron-right"></i> Iniciar conversa</a>
            <a href="#review"><i className="fas fa-chevron-right"></i> Avaliações</a>
            <a href="#blogs"><i className="fas fa-chevron-right"></i> Blog</a>
          </div>

          <div className="box">
            <h3>Nossos serviços</h3>
            <a href="#services"><i className="fas fa-chevron-right"></i> Licenciamento Ambiental e Regularização</a>
            <a href="#services"><i className="fas fa-chevron-right"></i> Flora</a>
            <a href="#services"><i className="fas fa-chevron-right"></i> Fauna</a>
            <a href="#services"><i className="fas fa-chevron-right"></i> Drones e Geoprocessamento</a>
            <a href="#services"><i className="fas fa-chevron-right"></i> Treinamentos e Capacitação</a>
            <a href="#services"><i className="fas fa-chevron-right"></i> Capex Opex</a>
          </div>

          <div className="box">
            <h3>Contato</h3>
            <a href="https://wa.me/5534999203789?text=Gostaria%20de%20atendimento%20estava%20navegando%20">
              <i className="fas fa-phone"></i> (34) 9 9920-3789
            </a>
            <a href="https://wa.me/5511986321639?text=Gostaria%20de%20atendimento%20estava%20navegando%20no%20site!%20">
              <i className="fas fa-phone"></i> (11) 9 8632-1639
            </a>
            <a href="mailto:emerson@biolinksolucoes.com.br?subject=Assunto%20do%20E-mail&body=Mensagem%20inicial">
              <i className="fas fa-envelope"></i> emerson@biolinksolucoes.com.br
            </a>
            <a href="#">
              <i className="fas fa-envelope"></i> omar.neto@biolinksolucoes.com.br
            </a>
            <a href="#">
              <i className="fas fa-map-marker-alt"></i> Uberlândia, Minas Gerais
            </a>
          </div>

          <div className="box">
            <h3>Conecte-se conosco!</h3>
            <a href="https://www.instagram.com/biolink_ambiental/">
              <i className="fab fa-instagram"></i> Instagram
            </a>
            <a href="https://www.linkedin.com/company/biolink-ambiental/posts/?feedView=all">
              <i className="fab fa-linkedin"></i> LinkedIn
            </a>
          </div>
        </div>

        <div className="credit">
          Criado por <span><a href="">Biolink</a></span> | ©Todos os direitos reservados.
        </div>
      </section>
    </div>
  );
};

export default ArticlePage;